import { AxiosResponse } from "axios";
import { FeedItemDto, FeedType, PublicationType } from "generated/CoreApi_v1";
import { BehaviorMode, CardSectionProps, CardSections, PublicationFeed } from "views/knowledge/components/card";
import { CardBuilder } from "views/knowledge/components/card/CardBuilder";
import { PublicationCardDefinitions } from "views/knowledge/components/card/CardDefinitions";

interface IProps<T> {
    feedType: FeedType;
    pub: T;
    otherInfo?: any;
    onFeedItemChanged: (data: Partial<T>) => void;
    onNeedResetRowHeight: () => void;
    onReload: () => void;
    onFeedReload?: () => void;
    onMarkRead?: () => Promise<AxiosResponse<boolean, any>>;
}

type CacheProps = {
    feedType: number;
    publicationType: PublicationType;
    behaviours: CardSectionProps;
    mode: BehaviorMode;
};

const cache: CacheProps[] = [];

export function getCardBehavior(section: CardSections, mode: BehaviorMode, feedType: FeedType, pub: FeedItemDto) {

    var item = PublicationCardDefinitions.find(p =>
        p.feedType == FeedType.Any
        && p.publicationType == pub.publicationType
        && p.section == section
        && (p.mode & mode) > 0
    );

    if (item == null) {
        item = PublicationCardDefinitions.find(p =>
            p.feedType == feedType
            && p.publicationType == pub.publicationType
            && p.section == section
            && (p.mode & mode) > 0
        );
    }

    return item?.behavior;
}

export const CardManager = (props: IProps<PublicationFeed>) => {

    const { feedType, pub } = props;

    // Modo de seleção em ordem de precedência: Deletado -> Bloqueado -> Oculto -> Thread -> Padrão.
    const mode = pub.deletedOn
        ? BehaviorMode.Deleted
        : pub.blocked?.blockedOn
            ? BehaviorMode.Blocked
            : !pub.interaction.isVisible && feedType == FeedType.Startup
                ? BehaviorMode.Hidden
                : pub.masterPublication != null
                    ? BehaviorMode.Thread
                    : pub.moderateReport && pub.moderateReport.comment && feedType == FeedType.ModerateReports
                        ? BehaviorMode.ModerateComment
                        : BehaviorMode.Default;

    let builderProps = cache.find(p =>
        p.feedType == feedType
        && p.publicationType == pub.publicationType
        && p.mode == mode
    );

    if (builderProps == undefined) {
        builderProps = {
            feedType,
            publicationType: pub.publicationType,
            mode: mode,
            behaviours: {
                PriorityHeader: getCardBehavior("priorityHeader", mode, feedType, pub),
                MediaHeader: getCardBehavior("mediaHeader", mode, feedType, pub),
                Classification: getCardBehavior("classification", mode, feedType, pub),
                Icons: getCardBehavior("icons", mode, feedType, pub),
                ExternalLeftThumbnail: getCardBehavior("externalLeftThumbnail", mode, feedType, pub),
                LeftThumbnail: getCardBehavior("leftThumbnail", mode, feedType, pub),
                RightThumbnail: getCardBehavior("rightThumbnail", mode, feedType, pub),
                Title: getCardBehavior("title", mode, feedType, pub),
                Author: getCardBehavior("author", mode, feedType, pub),
                Content: getCardBehavior("content", mode, feedType, pub),
                Media: getCardBehavior("media", mode, feedType, pub),
                Attach: getCardBehavior("attach", mode, feedType, pub),
                Task: getCardBehavior("task", mode, feedType, pub),
                Footer: getCardBehavior("footer", mode, feedType, pub),
            }
        };
        cache.push(builderProps);
    }

    return <CardBuilder
        dataRecord={props.pub}
        otherInfo={props.otherInfo ? { ...props.otherInfo, feedType } : { feedType }}
        onDataItemChanged={props.onFeedItemChanged}
        onNeedResetRowHeight={props.onNeedResetRowHeight}
        onReload={props.onReload}
        onFeedReload={props.onFeedReload}
        onMarkRead={props.onMarkRead}
        {...builderProps.behaviours}
    />;
};
